/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Email_SendingInputs */

const en_task_email_sending = /** @type {(inputs: Task_Email_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending email…`)
};

const pt_br2_task_email_sending = /** @type {(inputs: Task_Email_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando e-mail…`)
};

/**
* | output |
* | --- |
* | "Sending email…" |
*
* @param {Task_Email_SendingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_email_sending = /** @type {((inputs?: Task_Email_SendingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Email_SendingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_email_sending(inputs)
	return pt_br2_task_email_sending(inputs)
});